<div id="error-page">
  <div class="top-gray-bar"></div>
  <div class="uk-width-1-1 uk-width-5-6@m uk-width-1-2@xl uk-container uk-padding-remove">
    <div class="uk-margin-medium-top uk-margin-large-bottom uk-text-center">
      <img src="../../assets/img/pros/pros-ai-color.png" alt="PROS AI" style="width: 100%; max-width: 244px;"/>
    </div>
    <article class="uk-text-center">
      <h1 class="uk-article-title">{{ code }}</h1>
      @if (subTitle) {
        <h2 class="uk-margin-remove-top">{{ subTitle }}</h2>
      }
      <p class="uk-article-lead">{{ lead }}</p>
      <p class="uk-margin-large-top">
        @if (home) {
          <a class="uk-button uk-button-primary" [uiSref]="home.stateName || home.link"
          [uiParams]="home.uiParams">{{ home.title }}</a>
        } @else {
          <a class="uk-button uk-button-primary" href="/">Go Home</a>
        }
        <a class="uk-button uk-button-default em-btn-outline uk-margin-small-left"
          href="https://connect.pros.com/user/login?destination=/" target="_blank">Help Desk</a>
      </p>
      @if (0 < sections.length) {
        <div class="uk-margin-large-top">
          <ul class="uk-list">
            @for (section of sections; track section.id) {
              <li>
                <a [uiSref]="section.stateName || section.link" [uiParams]="section.uiParams">{{ section.title }}</a>
              </li>
            }
          </ul>
        </div>
      }
    </article>
    @if (errorDetails) {
      <div class="error-details uk-margin-large-top">
        <pre class="custom_code"><code class="language-js" opPrismHighlight>{{ errorDetails }}</code></pre>
      </div>
    }
  </div>
</div>
